import $ from "jquery";
import { onMounted } from "vue";
export default {
  name: "MetaIdentityComponent",
  inject: ["trackEvent"],
  setup(props) {
    const handleOnEnd = () => {
      console.log("end vdo");
      var media = document.querySelector(".video");
      media.pause();
      media.currentTime = 0;
    };

    onMounted(() => {
      //
    });

    return {
      handleOnEnd,
    };
  },
  mounted() {
    // document.querySelector("#volume-switcher").onchange = function () {
    //   alert("xx");
    //   document.querySelector("#theplayer").muted = !this.checked;
    // };
  },
};
